import { CountryDto } from "@cradua/data";
import { createReducer, on, Action, ActionReducerMap } from "@ngrx/store";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";

import * as EPIMSActions from "./anchorepimsgates.actions";

export const EpimsGate_FEATURE_KEY = "epimsgategeneric";
export const EpimsGate_FEATURE_KEY_Document = "epimsgategenericdocument";
export const EpimsGate_FEATURE_KEY_Language = "epimsgategenericlanguage";

export function EPIMSGate_FeatureKey(key: string) {
  return key;
}

export enum UploadStatus {
  Ready = "Ready",
  Requested = "Requested",
  Started = "Started",
  Failed = "Failed",
  Completed = "Completed",
}

export interface EPIMSGateState extends EntityState<any> {
  selectedId?: string | number; // which Model Type record has been selected
  loaded: boolean; // has the Model list been loaded
  error?: string | null; // last none error (if any)
  status: UploadStatus;
  progress: number | null;
}

// export function EPIMSGateState(interfaceName: string){

//     return interface interfaceName extends EntityState<any> {
//         selectedId?: string | number; // which Model Type record has been selected
//         loaded: boolean; // has the Model list been loaded
//         error?: string | null; // last none error (if any)
//       }
// }

export interface EPIMSGatePartialState {
  readonly [EpimsGate_FEATURE_KEY]: EPIMSGateState;
  readonly [EpimsGate_FEATURE_KEY_Document]: EPIMSGateState;
  readonly [EpimsGate_FEATURE_KEY_Language]: EPIMSGateState;
}

export const EPIMSGateAdapter: EntityAdapter<any> = createEntityAdapter<any>({
  selectId: (epimsgate) => epimsgate.id,
  sortComparer: false,
});

export const initialState: EPIMSGateState = EPIMSGateAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedId: null,
  status: UploadStatus.Ready,
  progress: null,
});

export const epimsReducer = (type: string) => {
  return createReducer(
    initialState,
    on(EPIMSActions.loadEpimsgate(type), (state) => ({
      ...state,
      loaded: true,
      error: null,
    })),
    on(
      EPIMSActions.loadEpimsgateSuccess(type),
      (state, { returnedData }) =>
        EPIMSGateAdapter.addAll(returnedData, { ...state, loaded: false }),
    ),
    on(EPIMSActions.loadEpimsgateFailure(type), (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })),
    on(EPIMSActions.addViaEpimsgate(type), (state) => ({
      ...state,
      loaded: true,
      error: null,
    })),
    on(
      EPIMSActions.addViaEpimsgateSuccess(type),
      (state, { returnedData }) =>
        EPIMSGateAdapter.addMany(returnedData, { ...state, loaded: false }),
    ),
    on(EPIMSActions.addViaEpimsgateFailure(type), (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })),
    on(EPIMSActions.updateViaEpimsgate(type), (state) => ({
      ...state,
      loaded: true,
      error: null,
    })),
    on(
      EPIMSActions.updateViaEpimsgateSuccess(type),
      (state, { returnedData }) =>
        EPIMSGateAdapter.upsertMany(returnedData, { ...state, loaded: false }),
    ),
    on(EPIMSActions.updateViaEpimsgateFailure(type), (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })),
    on(EPIMSActions.removeViaEpimsgate(type), (state, inputtype) => ({
      ...state,
      loaded: true,
      error: null,
    })),
    on(
      EPIMSActions.removeViaEpimsgateSuccess(type),
      (state, { ids }) =>
        EPIMSGateAdapter.removeMany(ids, { ...state, loaded: false }),
    ),
    on(EPIMSActions.removeViaEpimsgateFailure(type), (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })),
    on(EPIMSActions.documentUploadRequest, (state) => ({
      ...state,
      loaded: false,
      error: null,
      status: UploadStatus.Requested,
      progress: null,
    })),
    on(EPIMSActions.documentUploadCancel, (state) => ({
      ...state,
      loaded: false,
      error: null,
      status: UploadStatus.Ready,
      progress: null,
    })),
    on(EPIMSActions.documentUploadReset, (state) => ({
      ...state,
      loaded: false,
      error: null,
      status: UploadStatus.Ready,
      progress: null,
    })),
    on(EPIMSActions.documentUploadFailure, (state, { error }) => ({
      ...state,
      loaded: false,
      error: error,
      status: UploadStatus.Failed,
      progress: null,
    })),
    on(EPIMSActions.documentUploadStarted, (state) => ({
      ...state,
      loaded: false,
      error: null,
      status: UploadStatus.Started,
      progress: 0,
    })),
    on(EPIMSActions.documentUploadProgress, (state, { progress }) => ({
      ...state,
      loaded: false,
      error: null,
      progress: progress,
    })),
    on(EPIMSActions.documentUploadCompleted, (state) => ({
      ...state,
      loaded: false,
      error: null,
      status: UploadStatus.Completed,
      progress: 100,
    })),
  );
};

// const stakeholderReducer =

export function reducer(state: EPIMSGateState | undefined, action: Action) {
  // console.log("Action in Reducer ", action);

  return epimsReducer("Club")(state, action);
}

export function languagereducer(
  state: EPIMSGateState | undefined,
  action: Action,
) {
  return epimsReducer("Language")(state, action);
}

export function engagementreducer(
  state: EPIMSGateState | undefined,
  action: Action,
) {
  return epimsReducer("Engagement")(state, action);
}

export function documentreducer(
  state: EPIMSGateState | undefined,
  action: Action,
) {
  return epimsReducer("Document")(state, action);
}

export function mainReducer(state: EPIMSGateState | undefined, action: Action) {
  engagementreducer(state, action);
}

export interface AppState {
  anchorepimsengagement: EPIMSGateState;
  anchorepims: EPIMSGateState;
  anchorepimslanguage: EPIMSGateState;
  anchorepimsdocument: EPIMSGateState;
}

export const reducers: ActionReducerMap<AppState> = {
  anchorepimsengagement: engagementreducer,
  anchorepims: reducer,
  anchorepimslanguage: languagereducer,
  anchorepimsdocument: documentreducer,
};

export const reducerMain = {
  anchorepimsengagement1: engagementreducer,
  anchorepims1: reducer,
  anchorepimslanguage1: languagereducer,
  anchorepimsdocument: documentreducer,
};
